import {WorkflowTaskStore, Task} from '../../../modules/workflow/task/WorkflowTaskStore'
import {EntityTaskTypeButton} from '../../../modules/workflow/chromedome/EntityTaskTypeButton'
import {UncontrolledTooltip} from 'reactstrap';
import {taskTypes} from "../../../modules/workflow/models";
import React from 'react'

const mod = angular.module('clientDashboardApp')
mod.value('EntityTaskTypeButton', EntityTaskTypeButton)
mod.directive('reviewTaskButton', () => {
  const nextId = (() => {
    let id = 0;
    return () => "media-task-button" + id++;
  })();
  return {
    template: `
        <react-component name="EntityTaskTypeButton" props="buttonProps" watch-depth="reference"}></react-component>
      `,

    scope: {
      review: '=',
    },
    controller: ($scope) => {

      const id = nextId();

      $scope.buttonProps = {
        newTask: () => Task({
          taskType: 'RespondToReview',
          taskName: 'Respond to Review',
          entityType: 'Review',
          locationId: $scope.review.locationId.replace(/^legacy-/, ''),
          entityId: $scope.review._id
        }),
        entityId: $scope.review._id,
        entityType: 'Review',
        entityTaskTypes: taskTypes.filter(tt => tt.category === 'Reviews'),
        entityData: {review: $scope.review},
        trigger: <span>
          <button className="btn btn-link p-0 d-flex" id={id}>
            <i className="fas fa-check"></i>
          </button>
          <UncontrolledTooltip placement="top" target={id}>Tasks</UncontrolledTooltip>
        </span>,
      }
    }
  }
})
